import {
  Facebook,
  Instagram,
  Linkedin,
  MapPin,
  Phone,
  Mail,
  ArrowRight,
} from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "../assests/unitedLogo.png";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-white to-gray-50 text-gray-700 border-t border-gray-100">
      {/* TOP FOOTER */}
      <div className="max-w-7xl mx-auto px-4 py-20 grid lg:grid-cols-4 gap-6 lg:gap-14">
        {/* LOGO + ABOUT */}
        <div className="space-y-6">
          <img
            src={Logo}
            alt="We United Constructions"
            className="h-20 lg:h-24 mb-6 transition-transform duration-300 hover:scale-105"
          />

          <p className="text-gray-600 text-sm leading-relaxed">
            We United Constructions Ltd delivers high-quality residential,
            commercial, and civil construction services across the United
            Kingdom. We are committed to quality, safety, and long-term value.
          </p>

          
        </div>

        {/* QUICK LINKS */}
        <div>
          
          <ul className="space-y-5 text-sm text-gray-600">
            <h4 className="text-lg font-bold mb-1 lg:mb-6 text-[#082C5A] relative inline-block">
            Quick Links
            <span className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-[#F57C00] to-orange-300 rounded-full"></span>
          </h4>
            {[
              { name: "Home", path: "/" },
              { name: "About Us", path: "/about" },
              { name: "Services", path: "/services" },
              { name: "Contact", path: "/contact" },
              { name: "Privacy Policy", path: "/privacy-policy" },
            ].map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className="group hover:text-[#F57C00] transition-all duration-300 flex items-center gap-2 hover:gap-3"
                >
                  <ArrowRight
                    size={14}
                    className="text-[#F57C00] opacity-0 group-hover:opacity-100 transition-all duration-300 -ml-4 group-hover:ml-0"
                  />
                  <span className="relative">
                    {item.name}
                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#F57C00] group-hover:w-full transition-all duration-300"></span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>


        {/* MAP CARD */}
        {/* <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow duration-300">
          <iframe
            title="Company Location"
            src="https://www.google.com/maps?q=The%20Old%20School%20346%20Loughborough%20Road%20Leicester%20LE4%205PJ&output=embed"
            className="w-full h-64"
            loading="lazy"
          ></iframe>
        </div> */}
        <div>
        <ul className="space-y-5 text-sm text-gray-600">
          <h4 className="text-lg font-bold mb-1 lg:mb-6 text-[#082C5A] relative inline-block">
           Opening Hours
            <span className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-[#F57C00] to-orange-300 rounded-full"></span>
          </h4>

          <li className="group flex items-center gap-3">
            Monday to Friday – 8:30am to 5:30pm
          </li>
          <li className="group flex items-center gap-3">
            Saturday and Sunday – Closed
          </li>
        </ul>
        </div>

        {/* CONTACT INFO */}
        <div>
          <ul className="space-y-5 text-sm text-gray-600">
            <h4 className="text-lg font-bold mb-1 lg:mb-6 text-[#082C5A] relative inline-block">
            Contact Us
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-[#F57C00] to-orange-300 rounded-full"></span>
            </h4>

            <li className="group flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center flex-shrink-0">
                <Mail size={18} className="text-[#0B3C8A]" />
              </div>
              <a
                href="mailto:Hello@weunited.co.uk"
                className="hover:underline break-all"
              >
                Hello@weunited.co.uk
              </a>
            </li>
          </ul>
          <ul className="space-y-5 text-sm text-gray-600 mt-8">
            <h4 className="text-lg font-bold mb-1 lg:mb-6 text-[#082C5A] relative inline-block">
            Follow Us
              <span className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-[#F57C00] to-orange-300 rounded-full"></span>
            </h4>
            <li>
              {/* SOCIAL ICONS */}
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/WeUnitedConstructions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-11 h-11 flex items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 shadow-sm hover:shadow-lg text-[#0B3C8A] hover:scale-110 transition-all duration-300"
                >
                  <Facebook
                    size={18}
                    className="group-hover:scale-110 transition-transform"
                  />
                </a>
                <a
                  href="https://www.instagram.com/we_united_constructions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-11 h-11 flex items-center justify-center rounded-lg bg-gradient-to-br from-orange-50 to-orange-100 shadow-sm hover:shadow-lg text-[#F57C00] hover:scale-110 transition-all duration-300"
                >
                  <Instagram
                    size={18}
                    className="group-hover:scale-110 transition-transform"
                  />
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-11 h-11 flex items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 shadow-sm hover:shadow-lg text-[#0B3C8A] hover:scale-110 transition-all duration-300"
                >
                  <Linkedin
                    size={18}
                    className="group-hover:scale-110 transition-transform"
                  />
                </a>
              </div>
            </li>
          </ul>
        </div>
        
      </div>

      {/* BOTTOM FOOTER */}
      <div className="border-t border-gray-100 bg-gradient-to-r from-white via-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            {/* LEFT: LEGAL */}
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-center sm:text-left">
              <p className="text-sm text-gray-600">
                © {new Date().getFullYear()}{" "}
                <span className="font-semibold text-[#082C5A]">
                  We United Constructions Ltd
                </span>{" "}
                <span className="text-gray-500">– All rights reserved</span>
              </p>

              {/* dot divider (only on bigger screens) */}
              <span className="hidden sm:inline text-gray-300">•</span>

              {/* Company Reg "chip" */}
              <span className="inline-flex items-center justify-center rounded-full border border-gray-200 bg-white px-3 py-1 text-xs font-semibold text-gray-600 shadow-sm">
                Company Reg:{" "}
                <span className="ml-1 text-gray-800">16738573</span>
              </span>
            </div>

            {/* RIGHT: DEVELOPER */}
            <div className="flex items-center justify-center md:justify-end gap-2 text-sm text-gray-600">
              <span className="hidden sm:inline text-gray-400">
                Built with care by
              </span>

              <a
                href="https://impacttechlab.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 rounded-full border border-orange-100 bg-gradient-to-r from-orange-50 to-white px-4 py-2 font-semibold text-[#F57C00] shadow-sm hover:shadow-md transition-all duration-300"
              >
                <span className="relative">
                 Impact Techlab
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#0B3C8A] group-hover:w-full transition-all duration-300"></span>
                </span>

                {/* small arrow pill */}
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white border border-gray-200 text-[#082C5A] group-hover:translate-x-0.5 transition-transform duration-300">
                  ↗
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
